const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/`;

export { API_BASE_URL };
